import React from "react";
import { capitalize } from "../../utils/textFunctions";
import styles from "./FHIRPatient.module.scss";
import moment from "moment";
import RecordOverrideOptions from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideOptions";
import { overrideSummaryForGender } from "../../routes/NewSearchRecords/SearchRecordTable/RecordOverrideUtil";
import { handleMultipleAttributeOverrideSingleValued } from "../../routes/NewSearchRecords/SearchRecordTable/MultipleAttributeOverride/Utils";
import Modal from "../../components/ModalPopup";
import ButtonList from "../../components/ButtonList";
import Button from "../../components/Button";
import OverrideAuditInputModal from "../../routes/NewSearchRecords/SearchRecordTable/OverrideAuditInputModal";
import { ExtensionURLs } from "../../routes/NewSearchRecords/SearchRecordTable/GoldenRecordExclusion/Utils";

const Gender = ({
  data,
  summary: isSummary,
  extensions: extensions,
  oncRecordOverrideIconClick,
  overrideExtension,
  isInvisible = false,
  isNewQuarantine = false,
  isMultipleAttributeOverride = false,
  setAttributeOverrides,
  attributeOverrides,
}) => {
  const [replaceRecordOverrideDialog, setReplaceRecordOverrideDialog] =
    React.useState(false);
  const [recordOverrideDialogContent, setRecordOverrideDialogContent] =
    React.useState({});
  const [value, setValue] = React.useState("");
  const [valueChanged, setValueChanged] = React.useState(false);
  const [showAuditModal, setShowAuditModal] = React.useState(false);
  const [pendingConfirmDetails, setPendingConfirmDetails] =
    React.useState(null);

  if (isSummary) {
    return <div> Gender: {capitalize(data)}</div>;
  }
  const genderMap = {
    Field: "Gender",
    Gender: data ? capitalize(data) : "-",
    "Mark as": "",
    originalFieldName: "gender",
    originalFieldData: data,
    originalFieldDataCopy: data,
  };

  const prepareOverrideOriginalValue = (type) => {
    const extensionMap = overrideSummaryForGender(
      data,
      combinedOverrideExtension,
      type,
    );
    oncRecordOverrideIconClick(extensionMap);
  };

  const actionHandler = (detailsMap) => {
    if (isMultipleAttributeOverride) {
      handleMultipleAttributeOverrideSingleValued(
        detailsMap,
        "gender",
        attributeOverrides,
        setAttributeOverrides,
      );
      setReplaceRecordOverrideDialog(false);
    } else {
      oncRecordOverrideIconClick(detailsMap);
    }
  };

  const handleReplaceOverride = (detailsMap) => {
    if (detailsMap["Mark as"] && detailsMap["Mark as"] === "Replace") {
      if (detailsMap.originalFieldData) {
        setValue(detailsMap.originalFieldData);
      }
      setRecordOverrideDialogContent(detailsMap);
      setReplaceRecordOverrideDialog(true);
    } else {
      actionHandler(detailsMap);
    }
  };

  const handleConfirm = () => {
    const detailsMap = { ...recordOverrideDialogContent };
    detailsMap.originalFieldData = value;
    if (isMultipleAttributeOverride)
      // Directly proceed to next step without audit modal
      actionHandler(detailsMap);
    else {
      setPendingConfirmDetails(detailsMap);
      setShowAuditModal(true);
      // Do NOT call actionHandler(detailsMap) directly here
    }
  };

  const handleAuditSubmit = (auditInfo) => {
    if (pendingConfirmDetails) {
      const updatedDetails = {
        ...pendingConfirmDetails,
        auditInfoList: auditInfo,
      };
      actionHandler(updatedDetails);
      setPendingConfirmDetails(null);
    }
    setShowAuditModal(false);
  };

  const genderAuditUrls = [
    ExtensionURLs.genderOverriddenBy,
    ExtensionURLs.genderOverrideReason,
    ExtensionURLs.genderOverrideTimestamp,
  ];

  const genderAuditExtensions = (extensions || []).filter((e) =>
    genderAuditUrls.includes(e.url),
  );

  // Combine main overrideExtension with the audit extensions, avoiding duplicates
  const combinedOverrideExtension = [
    ...(overrideExtension || []),
    ...genderAuditExtensions.filter(
      (auditExt) =>
        !(overrideExtension || []).some(
          (mainExt) => mainExt.url === auditExt.url,
        ),
    ),
  ];

  const replaceOverrideModal = () => {
    return (
      <Modal
        open={replaceRecordOverrideDialog}
        onClose={() => setReplaceRecordOverrideDialog(false)}
      >
        <h3 style={{ textAlign: "center" }}>Replace override</h3>
        <br />
        <br />
        <div>
          {recordOverrideDialogContent && (
            <table className={"recOvrTable"}>
              <tr>
                <td>Gender</td>
              </tr>
              <tr>
                <td>
                  <select
                    value={value}
                    //onChange={e => setValue(e.target.value)}
                    onChange={(e) => {
                      setValue(e.target.value);
                      if (!valueChanged) {
                        setValueChanged(true);
                      }
                    }}
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </td>
              </tr>
            </table>
          )}
        </div>
        <br />
        <br />
        <div style={{ marginTop: "1rem" }}>
          <ButtonList
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              primary
              disabled={!valueChanged}
              onClick={() => handleConfirm()}
            >
              Confirm Changes
            </Button>
            <Button
              onClick={() => {
                setValueChanged(false);
                setReplaceRecordOverrideDialog(false);
              }}
            >
              Cancel
            </Button>
          </ButtonList>
        </div>
      </Modal>
    );
  };

  const genTimeStamp = extensions
    ? extensions.filter((e) => e.url.includes("genderTimeStamp"))
    : "";

  return (
    <>
      {/* AUDIT MODAL */}
      {showAuditModal && (
        <OverrideAuditInputModal
          isOpen={showAuditModal}
          onCancel={() => setShowAuditModal(false)}
          onSubmit={handleAuditSubmit}
        />
      )}
      <div>
        <h4>Gender</h4>
        {data ? (
          data.split(",").map((g) => <div>{capitalize(g)}</div>)
        ) : (
          <div>-</div>
        )}
        <div>
          <h6>
            {genTimeStamp[0]
              ? "Source Timestamp: " +
                moment(genTimeStamp[0].valueDateTime)
                  .tz("America/Chicago")
                  .format("l, LTS zz")
              : ""}
          </h6>
        </div>
      </div>
      {oncRecordOverrideIconClick && !isInvisible && !isNewQuarantine && (
        <div className={styles.actionColumn}>
          <h4>Action</h4>
          <RecordOverrideOptions
            detailsMap={genderMap}
            onClickRecordOverrideAction={(detailsMap) =>
              handleReplaceOverride(detailsMap)
            }
            disableInactiiveAndInvalid={true}
            onClickRecordOverrideButton={(type) =>
              prepareOverrideOriginalValue(type)
            }
            extension={combinedOverrideExtension}
            isMultipleAttributeOverride={isMultipleAttributeOverride}
            selectedOverrides={attributeOverrides.gender}
          />
        </div>
      )}
      {replaceOverrideModal()}
    </>
  );
};

export default Gender;
